const state = {
    setting: {},
    settingViewCountWeight: {},
    countTitle: {
        sumIt1: {
            title: 'Общее кол-во ключей в топ 1',
            abbr: '&sum; 1'
        },
        sumIt3: {
            title: 'Общее кол-во ключей в топ 3',
            abbr: '&sum; 3'
        },
        sumIt5: {
            title: 'Общее кол-во ключей в топ 5',
            abbr: '&sum; 5'
        },
        sumIt10: {
            title: 'Общее кол-во ключей в топ 10',
            abbr: '&sum; 10'
        },
        sumIt50: {
            title: 'Общее кол-во ключей в топ 50',
            abbr: '&sum; 50'
        },
        sumVis: {
            title: 'Сумма оценки видимости страниц в поиске.',
            abbr: 'Вид.'
        },
    }
};

// getters
const getters = {
    setting: () => state.setting,
    countTitle: () => state.countTitle,
    settingViewCountWeight: () => {
        let result = {};

        let getWeigh = function (value) {
            switch (value.formatMoney(0, ' ', ' ').length) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 5:
                case 6:
                    return 27;
                case 7:
                case 8:
                case 9:
                    return 35;
                default:
                    return 50;
            }

        };

        for (let p in state.settingViewCountWeight) {
            result[p] = getWeigh(state.settingViewCountWeight[p]);
        }

        return result;
    },
};

// mutations
const mutations = {
    setSetting(setting) {
        state.setting = setting
    },
    setSettingViewCountWeight(settingViewCountWeight) {
        state.settingViewCountWeight = settingViewCountWeight
    },
};

export const store = {
    getters,
    mutations
};
